module.exports = __webpack_public_path__ + "assets/img/logo.6ffd12a1.png";